import { render, staticRenderFns } from "./BackorderRowDetails.vue?vue&type=template&id=8adf4c9c"
import script from "./BackorderRowDetails.ts?vue&type=script&lang=ts&external"
export * from "./BackorderRowDetails.ts?vue&type=script&lang=ts&external"
import style0 from "./BackorderRowDetails.scss?vue&type=style&index=0&prod&lang=scss&external"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports